import type { useIssuesStore } from "@/stores/pm/hooks/usePMStore";
import {
  createIssueWithAssociations,
  type CreateIssueWithAssociationsParams,
  type PrefilledDrawingAnchor,
  type PrefilledElement,
} from "@/domains/pm/createIssueWithAssociations";

export type { PrefilledDrawingAnchor, PrefilledElement };

/** The create sequence's parameters, with a store that can also reload the list. */
export interface SubmitIssueFormParams
  extends Omit<CreateIssueWithAssociationsParams, "issuesStore"> {
  issuesStore: ReturnType<typeof useIssuesStore>;
}

/**
 * Create an issue plus every association the form owns, then reload the issue
 * list. Creation is `createIssueWithAssociations`, shared with the /issues
 * draft; this adds the dialog's reload.
 */
export async function submitIssueForm(p: SubmitIssueFormParams): Promise<void> {
  await createIssueWithAssociations(p);
  await p.issuesStore.loadIssues(p.buildingId);
}
